import { ROUTE_PATHS } from './types';

export const NAVBAR_ROUTES = [
  ROUTE_PATHS.MAIN,
  ROUTE_PATHS.FEED,
  ROUTE_PATHS.TASKS,
  ROUTE_PATHS.SEARCH,
  ROUTE_PATHS.WHEEL, // подержка роута, ведет в таски
] as const;
